<template>
<section class="services">
  <div class="container">
    <div class="services-top">
      <h2>Основные услуги</h2>
    </div>
    <div class="services-bottom">
      <div class="row">
        <div class="col">
          <div class="col-top" @click="fDesign ()">
            <router-link :to=" { name: 'Services' } ">
              <picture>
                <source srcset="../../public/static/images/sectionServices/1.webp">
                <img src="../../public/static/images/sectionServices/1.jpg" alt="">
              </picture>
            </router-link>
          </div>
          <div class="col-bottom">
            <p>3D-дизайн</p>
            </div>
        </div>
        <div class="col">
          <div class="col-top" @click="fRepair ()">
            <router-link :to=" { name: 'Services' } ">
              <picture>
                <source srcset="../../public/static/images/sectionServices/2.webp">
                <img src="../../public/static/images/sectionServices/2.jpg" alt="">
              </picture>
            </router-link>
          </div>
          <div class="col-bottom">
            <p>Ремонт</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'SectionServices',
  components: {
  },
  methods: {
    ...mapActions ([
      'filterIsDesign',
      'filterIsRepair'
    ]),
    fDesign () {
      this.filterIsDesign ()
    },
    fRepair () {
      this.filterIsRepair ()
    }
  },
  computed: {
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.services {
  background-color: #eee;
  padding: 45px 0;
  @media (max-width: 1199.98px) {
    padding: 45px 0 25px 0;
  }
  @media (max-width: 575.98px) {
    padding: 20px 0 0 0;
  }
  .row {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    @media (max-width: 1199.98px) {
      flex-wrap: wrap;
    }
    .col {
      flex: 0 0 50%;
      max-width: 50%;
      position: relative;
      height: auto;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      @media (max-width: 1199.98px) {
        flex: 1 1 50%;
        max-width: 50%;
        margin-bottom: 20px;
      }
      @media (max-width: 575.98px) {
        flex: 1 1 100%;
        max-width: 100%;
      }
      &-top {
        width: 100%;
        height: 400px;
        position: relative;
        overflow: hidden;
        margin-bottom: 20px;
        cursor: pointer;
        a {
          position: relative;
          width: 100%;
          height: 100%;
          display: block;
          &:after {
            position: absolute;
            z-index: -0;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            content: '';
            background-color: #000;
            opacity: 0;
            transition: .1s linear all;
          }
          &:hover {
            &:after {
              opacity: .6;
            }
          }
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      &-bottom {
        p {
          font-weight: 500;
          font-size: 2.6rem;
          color: #0E0E0E;
          position: relative;
          padding-left: 20px;
          &:before {
            content: '';
            position: absolute;
            width: 12px;
            height: 12px;
            left: 0;
            top: 0;
            background: #4F4F4F
          }
        }
      }
    }
  }
}
</style>
